import { render } from "./gf1satinfo.vue?vue&type=template&id=322393dc&scoped=true"
const script = {}

import "./gf1satinfo.vue?vue&type=style&index=0&id=322393dc&scoped=true&lang=css"

import exportComponent from "E:\\lb\\vue30\\tuiguang_meng\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-322393dc"]])

export default __exports__